"use client";

import { useEffect, useState, useMemo } from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";

import { Tabs, TabsContent } from "@/components/ui/tabs";
// import {
//   Accordion,
//   AccordionContent,
//   AccordionItem,
//   AccordionTrigger,
// } from "../ui/accordion";
import { useGetSearchProducts } from "@/hooks/ApiHooks/productHooks/getSearchProductsHook";
import HeaderSearchAndCategory from "./HeaderSearchAndCategory";
import { motion } from "framer-motion";
import { NoImage } from "../../../public";
import HeaderSearchSkelton from "./skeltons/HeaderSearchSkelton";
import QuoteIcon from "./QuoteIcon";
import Loader from "./Loader";
// import { useProductListingStore } from "@/zustand/productListingStore"

export default function Header() {

  const router = useRouter();
  const pathname = usePathname();

  const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);
  const [isOpenProductSearchPopover, setIsOpenProductSearchPopover] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  // Close menu and reset loading state when route changes
  useEffect(() => {
    setIsOpenMobileMenu(false);
    setIsNavigating(false);
  }, [pathname]);
  // const [parentId, setParentId] = useState(0);
  // const [openAccordion, setOpenAccordion] = useState<string | undefined>(undefined);
  // const setCategoryIdToStore = useProductListingStore((state) => state.setCategoryIdToStore);
  // const setSubCategoryIdToStore = useProductListingStore((state) => state.setSubCategoryIdToStore);

  // Debounce search term (mobile popover) to avoid API per keystroke
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  useEffect(() => {
    const handle = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 1000);
    return () => clearTimeout(handle);
  }, [searchTerm]);

  const { data: searchData } = useGetSearchProducts(debouncedSearchTerm);
  // const { data: subCategoryData } = useGetAllSubCategories(parentId);

  const togglePopover = () => setIsOpenProductSearchPopover((prev) => !prev);
  const closePopover = () => setIsOpenProductSearchPopover(false);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");
    if (!hasVisited) {
      setShowAnimation(true);
      sessionStorage.setItem("hasVisited", "true");
    }
  }, []);

  // Memoize mobile menu items for state management
  const mobileMenuItems = useMemo(() => [
    {
      label: "ALL PRODUCTS",
      icon: "/images/all-product-icon.svg",
      link: "/product-category/all-products",
      ariaLabel: "View all building material products",
      onClick: () => {
        if (pathname === "/product-category/all-products") {
          setIsOpenMobileMenu(false);
        } else {
          setIsNavigating(true);
          router.push("/product-category/all-products");
        }
      },
    },
    {
      label: "ABOUT US",
      icon: "/images/about-us-icon.svg",
      link: "/about-us",
      ariaLabel: "Learn more about Gemini Building Materials",
      onClick: () => {
        if (pathname === "/about-us") {
          setIsOpenMobileMenu(false);
        } else {
          setIsNavigating(true);
          router.push('/about-us');
        }
      },
    },
    {
      label: "NEWS & BLOGS",
      icon: "/images/news-and-blog.svg",
      link: "/blogs",
      ariaLabel: "Read our latest news and blogs",
      onClick: () => {
        if (pathname === "/blogs") {
          setIsOpenMobileMenu(false);
        } else {
          setIsNavigating(true);
          router.push('/blogs');
        }
      },
    },
    {
      label: "CONTACT US",
      icon: "/images/contact-us-icon.svg",
      link: "/contact-us",
      ariaLabel: "Get in touch with us",
      onClick: () => {
        if (pathname === "/contact-us") {
          setIsOpenMobileMenu(false);
        } else {
          setIsNavigating(true);
          router.push('/contact-us');
        }
      },
    },
  ], [router, pathname]);

  return (
    <motion.div
      className="text-White bg-white"
      initial={showAnimation ? { opacity: 0, y: -150 } : false}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.8,
        delay: 2, // Waits 0.5s before starting
      }}
    >
      {/* top secondary header */}
      <div className="bg-[#F0F0F0]">
        <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto py-mob-10 sm:py-tab-10 lg:py-web-10 hidden sm:flex  justify-between items-center">
          {/* <p className="text-mob-12 sm:text-tab-13 lg:text-web-18 leading-[120%] text-[#565656]">
            <span className="text-[#313131] ">News:</span> New Product Launch,
            Knauf Medium density board.{" "}
            <span className="text-[#313131] underline cursor-pointer">
              Click here
            </span>
          </p> */}
          <div className="hidden lg:flex gap-web-24 text-[#313131] text-web-15 font-medium uppercase tracking-[0.18vw] lg:ml-auto">

            <Link href="/about-us">
              <div className="flex">About Us</div>
            </Link>

            <div className="w-web-6">
              <Image
                src="/images/dote.svg"
                alt="telephone-icon"
                fill
                className="!static"
              />
            </div>

            <Link href="/contact-us">
              <div className="flex">
                Contact Us
              </div>
            </Link>

            <div className="w-web-6">
              <Image
                src="/images/dote.svg"
                alt="telephone-icon"
                fill
                className="!static"
              />
            </div>

            <Link href="/blogs" aria-label="Visit our News and Blogs page">
              <div className="flex">
                Blogs
              </div>
            </Link>

            <div className="w-web-6">
              <Image
                src="/images/dote.svg"
                alt="telephone-icon"
                fill
                className="!static"
              />
            </div>

            <div className="flex items-center gap-web-10">
              <div className="w-web-18">
                <Image
                  src="/images/telephone.svg"
                  alt="telephone-icon"
                  fill
                  className="!static"
                />
              </div>
              <a href="tel:+97126740505">
                +971 26740505
              </a>
            </div>

          </div>
        </div>
      </div>

      {/* header */}
      <div className="text-black">
        <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto py-mob-24 sm:py-tab-24  lg:py-web-38 flex items-end lg:justify-between bg-White ">

          {/* toggle menu btn */}
          <div
            className="w-mob-32 sm:w-tab-32 mr-mob-15 sm:mr-tab-15 lg:hidden mb-mob-3 sm:mb-tab-3"
            onClick={() => setIsOpenMobileMenu(true)}
          >
            <Image
              src="/images/toggle-menu.svg"
              alt="eye-icon"
              fill
              className="!static !h-full object-cover w-full object-center"
            />
          </div>

          {/* logo */}
          <Link href="/">
            <motion.div
              className="w-[30.23vw] sm:w-[18.22vw] lg:w-[10.41vw] relative z-[145]"
              whileHover={{ scale: 1.05 }} // Slightly enlarges on hover
              whileTap={{ scale: 1 }}
            >
              <Image
                src="/images/gemini-logo.svg"
                alt="eye-icon"
                fill
                className="!static !h-auto"
              />
            </motion.div>
          </Link>

          {/* search product & all products */}
          <HeaderSearchAndCategory onSearchFocusChange={setIsSearchFocused} />

          {/* store locator */}
          <Link href="/contact-us#store-location">
            <div className="hidden group  lg:flex items-center gap-web-15 lg:pb-web-6 relative z-[145]  cursor-pointer ">
              <div className="w-web-24 transition-all duration-200 group-hover:scale-105">
                <Image
                  src="/images/locator.svg"
                  alt="eye-icon"
                  fill
                  className="!static !h-auto"
                />
              </div>
              <span className="block text-web-15 font-medium leading-[120%] uppercase tracking-[0.23vw] text-PrimaryLightBlue">
                Store Locator
              </span>
            </div>
          </Link>

          {/* search products btn only mobile view */}
          <div
            className="hidden group lg:hidden items-center gap-mob-8 ml-auto py-mob-6 border-b-[0.260vw] border-[#DADADA]"
            onClick={togglePopover}
          >
            <span className="text-mob-11 font-medium uppercase text-black/50 tracking-[0.51vw]">
              Search Products...
            </span>
            <div className="w-mob-18 transition-all duration-200 group-hover:scale-105">
              <Image
                src="/images/search.svg"
                alt="icon"
                fill
                className="!static !h-full object-cover w-full object-center"
              />
            </div>
          </div>

        </div>
      </div>

      {/* Sticky Quote Icon - Positioned at extreme right */}
      <QuoteIcon isMobileMenuOpen={isOpenMobileMenu} isSearchFocused={isSearchFocused} />

      {/* mobile & tab menu */}
      {isOpenMobileMenu && (
        <motion.div
          className="fixed w-full h-screen left-0 top-0 bg-white z-[150]  pt-mob-58 pb-mob-25 sm:pt-tab-59 lg:hidden"
          initial={{ opacity: 0, originX: 0, originY: 0 }}
          animate={{ opacity: isOpenMobileMenu ? 1 : 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 15, opacity: { duration: 0.5 } }}
        >
          <div className="relative  max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto flex flex-col justify-stretch h-full">

            {/* head */}
            <div className="flex items-end  grow-0 mb-mob-40 sm:mb-tab-55">

              {/* close btn */}
              <div
                className="w-mob-32 sm:w-tab-32 mr-mob-15 sm:mr-tab-15 lg:hidden mb-mob-3 sm:mb-tab-3"
                onClick={() => setIsOpenMobileMenu(false)}
              >
                <Image
                  src="/images/closeBtn.svg"
                  alt="icon"
                  fill
                  className="!static !h-full object-cover w-full object-center"
                />
              </div>

              {/* logo */}
              <div
                className="w-[30.23vw] sm:w-[18.22vw]"
                onClick={() => setIsOpenMobileMenu(false)}
              >
                <Link href="/">
                  <Image
                    src="/images/gemini-logo.svg"
                    alt="eye-icon"
                    fill
                    className="!static !h-full object-cover w-full object-center"
                  />
                </Link>
              </div>

              {/* store locator btn */}
              <div className="flex items-center gap-mob-15 sm:gap-tab-15 ml-auto">
                <Link href="/contact-us#store-location" onClick={() => setIsOpenMobileMenu(false)}>
                  <div className="flex items-center gap-mob-7 sm:gap-tab-7">
                    <div className="w-mob-24 sm:w-tab-24">
                      <Image
                        src="/images/locator.svg"
                        alt="eye-icon"
                        fill
                        className="!static !h-auto"
                      />
                    </div>
                    <span className="block text-mob-15 sm:text-tab-15 font-medium leading-[120%] uppercase tracking-[0.59vw] sm:tracking-[0.33vw]  text-PrimaryLightBlue">
                      Store Locator
                    </span>
                  </div>
                </Link>
              </div>

            </div>

            {/* body */}
            <div className="grow mob-menu-tab w-full px-mob-45 sm:px-tab-45">
              <Tabs
                defaultValue="all-products"
                className="h-full flex flex-col"
              >
                <div className="grow overflow-y-auto relative h-[1px]">
                  <TabsContent value="all-products">
                    <ul className="flex flex-col sm:gap-tab-38 justify-center my-[7vw]">
                      {mobileMenuItems.map((item) => (
                        <li
                          key={item.label}
                          className="flex items-center"
                          style={{ touchAction: 'manipulation' }}
                        >
                          <Link
                            href={item.link}
                            aria-label={item.ariaLabel || item.label}
                            onClick={(e) => {
                              e.preventDefault();
                              item.onClick();
                            }}
                            onTouchStart={(e) => {
                              e.preventDefault();
                              item.onClick();
                            }}
                            className="flex items-center gap-mob-20 py-[3.5vh] cursor-pointer w-full"
                          >
                            <div className="w-mob-32 sm:w-tab-32 lg:w-web-54 h-auto">
                              <Image
                                src={item.icon}
                                alt={item.label.toLowerCase().replace(/ /g, "-")}
                                width={54}
                                height={54}
                                className="w-full h-auto"
                              />
                            </div>
                            <span className="block text-[#323232] text-mob-15 sm:text-tab-15 lg:text-web-20 leading-[150%] font-medium">
                              {item.label}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </TabsContent>
                </div>
              </Tabs>
            </div>
          </div>
          {/* foot */}
          <div className="sticky inset-x-0 bottom-0 grow-0 bg-PrimaryLightBlue mt-mob-30 sm:mt-tab-30 z-50 w-full">
            <div className="flex h-[20vh] flex-col gap-[5.4884vw] ml-[7vw] sm:gap-tab-15 px-mob-45 sm:px-tab-45 pt-[10vw] sm:py-tab-30">
              {/* Phone Contact */}
              <div className="flex items-center gap-mob-10 sm:gap-tab-10">
                <div className="w-mob-30 sm:w-tab-30 h-auto">
                  <Image
                    src="/images/telephone-2.svg"
                    alt="contact-us"
                    fill
                    className="!static !h-auto"
                  />
                </div>
                <span className="text-white text-mob-18 sm:text-tab-18 leading-[150%] font-medium">

                  <a href="tel:+97126740505" onClick={() => setIsOpenMobileMenu(false)} >
                    +971 2 6740505
                  </a>
                </span>
              </div>

              {/* Email Contact */}
              <div className="flex items-center gap-mob-10 sm:gap-tab-10">
                <div className="w-mob-30 sm:w-tab-30 h-auto">
                  <Image
                    src="/images/mail-icon-2.svg"
                    alt="contact-us"
                    fill
                    className="!static !h-auto"
                  />
                </div>
                <span className="text-white text-mob-18 sm:text-tab-18 leading-[150%] font-medium">

                  <a href="mailto:contact@geminiae.ae" onClick={() => setIsOpenMobileMenu(false)} >
                    CONTACT@GEMINIAE.AE
                  </a>
                </span>
              </div>
            </div>
          </div>
          {/* Loading Overlay */}
          {isNavigating && (
            <motion.div
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              className="absolute inset-0 bg-white/80 backdrop-blur-sm z-[200] flex items-center justify-center"
            >
              <div className="flex flex-col items-center gap-mob-20">
                <Loader />
              </div>
            </motion.div>
          )}
        </motion.div>
      )}

      {/* mobile & tab search popover overlay */}
      {isOpenProductSearchPopover && (
        <div
          className="fixed w-full h-full left-0 top-0 bg-black/70 z-[148]"
          onClick={closePopover}
        >
          {" "}
        </div>
      )}

      {/* popover */}
      {isOpenProductSearchPopover && (
        <motion.div
          initial={{ opacity: 0.6 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed w-[90%] sm:w-[70%] h-fit sm:h-[68dvh] bg-White left-[50%] top-[50%] transform -translate-x-[50%] -translate-y-[50%]  z-[150] pt-mob-38 sm:pt-tab-28 px-mob-27 sm:px-tab-27 pb-mob-55 sm:pb-tab-45"
        >

          <div className="flex items-center border-b border-[#DADADA] mb-mob-45 sm:mb-tab-24">
            <input
              type="text"
              placeholder="Search Products..."
              className="grow py-mob-7 sm:py-tab-7 text-mob-13 sm:text-tab-13 uppercase tracking-[0.51vw] sm:tracking-[0.28vw] placeholder:text-[#858585] text-black outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="w-mob-19 sm:w-tab-19">
              <Image
                src="/images/search.svg"
                alt="eye-icon"
                fill
                className="!static !h-auto "
              />
            </div>
          </div>

          <ul className="gap-mob-20 sm:gap-tab-20 flex flex-col mb-mob-45 sm:mb-tab-45 h-[60dvh] sm:h-[50vw] overflow-y-auto">

            {
              searchData && searchData.length > 0 ? (
                searchData.map((product: { id: string; name: string; slug: string; images?: { src: string }[] }) => (
                  <li
                    key={product.id}
                    className="w-full bg-White rounded-mob-10 sm:rounded-tab-10 border border-[#E4E4E4] flex gap-mob-11 sm:gap-tab-11 p-mob-12 sm:p-tab-12"
                    onClick={() => {
                      router.push(`/details/${product?.slug || product?.name}`);
                      closePopover();
                      setSearchTerm("")
                    }}
                  >
                    <div className="px-1 max-w-mob-80 min-w-mob-80 max-h-mob-80 min-h-mob-80 sm:max-w-tab-80 sm:min-w-tab-80 sm:max-h-tab-80 sm:min-h-tab-80 rounded-mob-10 sm:rounded-tab-10 overflow-hidden cursor-pointer">
                      <Image
                        src={product?.images?.[0]?.src || NoImage}
                        alt="product"
                        fill
                        className="!static !h-full w-full object-center"
                      />
                    </div>
                    <span className="text-[#323232] text-mob-16 sm:text-tab-16 font-medium leading-[120%] capitalize cursor-pointer">
                      {product.name}
                    </span>
                  </li>
                ))
              ) : (searchTerm ? <HeaderSearchSkelton /> : "")
            }

          </ul>

          {
            searchData && searchData.length > 0 && searchTerm ? (
              <span
                className="flex items-center gap-mob-10 sm:gap-tab-10 lg:gap-web-10 uppercase justify-center text-PrimaryLightBlue text-mob-15 sm:text-tab-15 lg:text-web-15 font-medium leading-mob-18 sm:leading-tab-18 lg:leading-web-18 tracking-[1.046vw] sm:tracking-[0.58vw] lg:tracking-[0.234vw]"
                onClick={() => {
                  router.push(`/product-category/all-products?search=${searchTerm}`);
                  closePopover();
                }}
              >
                MORE PRODUCTS
                <div className="w-mob-7 sm:w-tab-7 lg:w-web-7 h-auto">
                  <Image
                    src="/images/chevron-right-blue.svg"
                    alt="Blurred Image"
                    fill
                    className="!static "
                  />
                </div>
              </span>
            )
              : ""
          }

        </motion.div>
      )}
    </motion.div>
  );
}